<template>
  <v-lazy style="min-width: 0" :options="{ threshold: 0.5 }" @update:model-value="onVisible">
    <div class="ag-truncated-text">
      <div v-if="$slots.prepend || prependIcon.icon" class="ag-truncated-text__prepend">
        <slot name="prepend">
          <div :class="['ag-truncated-text__prepend', prependIcon.bgColor, prependIcon.padding]">
            <AGIcon
              class="ag-truncated-text__icon"
              :color="prependIcon.color"
              :icon="prependIcon.icon"
              :animation="prependIcon.animation"
              :size="prependIcon.size"
            />
          </div>
        </slot>
      </div>

      <AGTooltip :disabled="!isTruncated || hideTooltip" :clamp="tooltipProps.clamp">
        <template #activator="{ props }">
          <div v-bind="props" class="ag-truncated-text__activator" :class="contentClass">
            <slot />
          </div>
        </template>

        <template #default>
          <slot />
        </template>
      </AGTooltip>
    </div>
  </v-lazy>
</template>

<script>
import AGIcon from '@/components/common/AGIcon.vue';
import AGTooltip from '@/components/common/AGTooltip.vue';
import { ModelIconProps } from '@/model/common/ModelIconProps';

export default {
  components: {
    AGIcon,
    AGTooltip,
  },
  props: {
    text: {
      type: [String, Number],
      default: undefined,
    },
    hideTooltip: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: [String, Function, Object],
      default: '',
    },
    /** @type {PropType<AGTooltipProps>} */
    tooltipProps: {
      type: Object,
      default: () => ({}),
    },
    prependIcon: {
      type: Object,
      default: () => new ModelIconProps(),
    },
  },
  data: () => ({
    isTruncated: false,
  }),
  methods: {
    onVisible() {
      this.$nextTick().then(() => {
        const el = this.$el.querySelector('.ag-truncated-text__activator');
        this.isTruncated = el.clientWidth < el.scrollWidth;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-truncated-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  &__activator {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    flex: 1;
  }

  &__prepend {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    border-radius: 50%;
  }
}
</style>
